// extracted by mini-css-extract-plugin
export default {"CountryPhoneSelect":"styles_CountryPhoneSelect__gbo8+"};